import type { Mission } from '../missions.ts'

export const irs: Mission = {
  id: "irs",
  name: "Internal Revenue Service",
  short: "IRS",
  call: "Taxpayers",
  kind: "subagency",
  parent: "treasury",
  url: "https://www.irs.gov/",
  established: 1862,
  palette: {
    primary: "#00599c",
    secondary: "#002d62",
    accent: "#efce5a",
  },
  colorSource: {
    kind: "site",
    url: "https://www.irs.gov/",
  },
  motif: "eagle",
  mission: {
    text: "Provide America's taxpayers top quality service by helping them understand and meet their tax responsibilities and enforce the law with integrity and fairness to all.",
    url: "https://www.irs.gov/about-irs/the-agency-its-mission-and-statutory-authority",
  },
  fact: {
    text: "Created in 1862 as the Bureau of Internal Revenue to help fund the Civil War, it was renamed the Internal Revenue Service in 1953.",
    url: "https://www.archives.gov/chicago/finding-aids/irs",
  },
  seal: {
    file: "public/seals/irs.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Internal_Revenue_Service.svg",
  },
  logo: {
    file: "public/logos/irs.svg",
    source: "https://commons.wikimedia.org/wiki/File:Logo_of_the_Internal_Revenue_Service.svg",
  },
  identifier: {
    about: "https://www.irs.gov/about-irs",
    accessibility: "https://www.irs.gov/accessibility",
    foia: "https://www.irs.gov/privacy-disclosure/irs-freedom-of-information-act",
    noFear: "https://home.treasury.gov/footer/no-fear-act",
    oig: "https://www.tigta.gov/",
    performance: "https://www.irs.gov/about-irs/financial-and-budget-reports",
    privacy: "https://www.irs.gov/privacy-disclosure/irs-privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/irs-headquarters.jpg",
        small: "/media/irs-headquarters-sm.jpg",
        alt: "Black-and-white view along the long colonnaded Constitution Avenue facade of the Internal Revenue Service Headquarters Building, with traffic in the foreground.",
        title: "Internal Revenue Service Headquarters Building, Constitution Avenue facade, Washington, D.C., 1993 (HABS DC-657)",
        creator: "Jack E. Boucher, Historic American Buildings Survey, National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:Perspective_view_looking_along_the_Constitution_Avenue_facade,_showing_the_twenty-seven_bays_and_the_three_central_arches_that_mark_the_entrance_to_the_building_-_Internal_Revenue_HABS_DC,WASH,657-30.tif",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/irs-constitution-avenue.jpg",
        small: "/media/irs-constitution-avenue-sm.jpg",
        alt: "Black-and-white elevation of the Internal Revenue Service Headquarters Building seen across a lawn, framed by bare winter trees.",
        title: "Internal Revenue Service Headquarters Building, elevation of the Constitution Avenue facade, Washington, D.C., 1993 (HABS DC-657)",
        creator: "Jack E. Boucher, Historic American Buildings Survey, National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:Elevation_view_of_the_Constitution_Avenue_facade_-_Internal_Revenue_Service_Headquarters_Building,_1111_Constitution_Avenue_Northwest,_Washington,_District_of_Columbia,_DC_HABS_DC,WASH,657-32.tif",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
